// Shared utilities & constants for Pilots components

export const DECISION_LABELS = {
  pending: "Pendiente",
  scale: "Escalar",
  extend: "Extender",
  discard: "Descartar",
};

export const DECISION_COLORS = {
  pending: "bg-slate-100 text-slate-700",
  scale: "bg-green-100 text-green-700",
  extend: "bg-amber-100 text-amber-700",
  discard: "bg-red-100 text-red-700",
};

export const EMPTY_PILOT_FORM = {
  initiative_id: "",
  name: "",
  objective: "",
  hypothesis: "",
  partner_id: "",
  duration_weeks: 8,
  cost_estimated: "",
  // Enriched fields (Feb 2026)
  sponsor: "",
  sponsor_email: "",
  business_line: "",
  real_cost_eur: "",
  effort_hours_total: "",
};

export const EMPTY_CIERRE = {
  resumen_ejecutivo: "",
  objetivos_alcanzados: "",
  kpis_resultados: [],
  lecciones_aprendidas: [],
  proximos_pasos: "",
  recomendaciones: "",
  closure_date: "",
  // Propuesta presentada (Jul 2026)
  propuesta_presentada: false,
  propuesta_fecha: "",
  propuesta_doc_url: "",
};
